var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#585871"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H23.5C23.8978 13 24.2794 13.158 24.5607 13.4393C24.842 13.7206 25 14.1022 25 14.5V25C25 25.3978 24.842 25.7794 24.5607 26.0607C24.2794 26.342 23.8978 26.5 23.5 26.5H14.5C14.1022 26.5 13.7206 26.342 13.4393 26.0607C13.158 25.7794 13 25.3978 13 25V14.5C13 14.1022 13.158 13.7206 13.4393 13.4393C13.7206 13.158 14.1022 13 14.5 13H16",
    stroke: "#585871",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 11.5H16.75C16.3358 11.5 16 11.8358 16 12.25V13.75C16 14.1642 16.3358 14.5 16.75 14.5H21.25C21.6642 14.5 22 14.1642 22 13.75V12.25C22 11.8358 21.6642 11.5 21.25 11.5Z",
    stroke: "#585871",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2264 18.3459H18.8264",
    stroke: "#585871",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2264 20.746H21.2264",
    stroke: "#585871",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2264 23.146H21.2264",
    stroke: "#585871",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistoryIcon);
export default __webpack_public_path__ + "static/media/order-history-icon.5377ae7bd034252d5403b3198d99e9b3.svg";
export { ForwardRef as ReactComponent };